<template>
    <div style="display: table; width:100%; height:100vh">
        <div class="main-container">
            <div id="firebaseui-auth-container" style="width:100%; margin:0 auto" />
        </div>
    </div>
</template>

<script>

    import FB from 'firebase'
    import firebase from '@/firebase/firebase.js'
    
    var firebaseui = require("firebaseui-ja")
    require("firebaseui-ja/dist/firebaseui.css")

    export default {
        data: function () {
            return {
                mail: null,
                password: null
            }
        },
        mounted: function () {
            const self = this
            var ui = firebaseui.auth.AuthUI.getInstance()
            if (!ui){
                ui = new firebaseui.auth.AuthUI(firebase.auth())
            }
            ui.start(
                "#firebaseui-auth-container",
                {
                    callbacks: {
                        uiShown: function() {
                            console.log("uiShown")
                        },
                        signInSuccessWithAuthResult: function(authResult, redirectUrl) {                            
                            console.log("signInSuccessWithAuthResult", authResult, redirectUrl)
                            console.log(self.$router)
                            self.$router.push("/")
                        },
                        signInFailure: function(error) {
                            console.log("signInFailure")
                        }
                    },
                    autoUpgradeAnonymousUsers: false,
                    signInFlow: "redirect",
                    signInSuccessUrl: "/",
                    signInOptions: [
                        FB.auth.EmailAuthProvider.PROVIDER_ID
                    ]
                })
        }
    }
</script>

<style scoped>
    .main-container {
        height: 100vh;
        display: table-cell;
        vertical-align: middle;
    }
</style>
